import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	focus: null,
	ids: [],
	objectIds: [],
	objectSelectionOrigin: null, // 'click' | 'multi'
}

export const selectionSlice = createSlice({
	name: 'selection',
	initialState,
	reducers: {
		setSelection: (s, { payload }) => {
			const { focus, ids } = payload
			if (ids?.length) {
				// Actively taking focus — clear everything and establish new focus
				s.focus = focus
				s.ids = ids
				s.objectIds = []
				s.objectSelectionOrigin = null
			} else {
				// Deselecting own domain — only clear focus if we currently own it
				s.ids = []
				if (s.focus === focus) s.focus = null
			}
		},
		setObjectSelection: (s, { payload }) => {
			s.objectIds = payload || []
			s.ids = []
			s.focus = payload?.length ? 'object' : null
			s.objectSelectionOrigin = payload?.length === 1 ? 'click' : 'multi'
		},
		clearSelection: s => {
			s.focus = null
			s.ids = []
			s.objectIds = []
			s.objectSelectionOrigin = null
		},
		clearObjectSelection: s => {
			s.objectIds = []
			s.objectSelectionOrigin = null
			if (s.focus === 'object') s.focus = null
		},
		addObjectIds: (s, { payload }) => {
			const idsToAdd = Array.isArray(payload) ? payload : [payload]
			idsToAdd.forEach(id => {
				if (!s.objectIds.includes(id)) {
					s.objectIds.push(id)
				}
			})
			s.ids = []
			s.focus = 'object'
			s.objectSelectionOrigin = 'click'
		},
	},
	extraReducers: b => {
		// A peer's edit arrives as an `objects` patch, every echo of a local drag included: only the ids it deletes (`null`) leave the selection.
		b.addCase('live/patchLiveObject', (s, { payload }) => {
			if (!payload.objects) return
			const kept = s.objectIds.filter(id => payload.objects[id] !== null)
			if (kept.length === s.objectIds.length) return
			s.objectIds = kept
			if (kept.length) return
			s.objectSelectionOrigin = null
			if (s.focus === 'object') s.focus = null
		})
		b.addCase('editor/setCurrentTool', (s, { payload }) => {
			if (payload.startsWith('add_')) {
				s.objectIds = []
				s.objectSelectionOrigin = null
				if (s.focus === 'object') s.focus = null
			}
		})
	},
})

export const { setSelection, setObjectSelection, clearSelection, clearObjectSelection, addObjectIds } =
	selectionSlice.actions

export default selectionSlice.reducer
